import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import { hist } from "../index";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Footer from "../components/Footer/Footer.jsx";

import pagesRoutes from "../routes/pages";

import pagesStyle from "../assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";

import bgImage from "../assets/img/bgImage.jpg";

import { domain, getData } from "../utils/util";
import ChangePassword from "../components/Custom/ChangePassword";
// import DashBoard from "../views/BerPay/dashboard";
import qs from "qs";
import axios from "axios";

class Pages extends React.Component {
  componentDidMount() {
    let BerPay_Admin = getData("BerPay_Admin");
    //console.log("1");
    if (BerPay_Admin) {
      //console.log("2");
      if (
        window.location.pathname &&
        window.location.pathname.includes("/admin/pages/dashboard")
      ) {
        // console.log("3");
        // let url = "http://localhost:3000/admin/pages/dashboard?token";
        // let url =
        //   "https://berpayphase2dev.affleprojects.com/admin/pages/dashboard?token";
        let url = process.env.REACT_APP_TOKEN_URL;
        const parsedString = qs.parse(window.location.href);
        const token = (parsedString && parsedString[`${url}`]) || "";
        // console.log("**********", token, parsedString);
        if (token) {
          let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
          //console.log("4", data);

          if (data) {
            data = {
              ...data,
              token: token,
            };
            localStorage.setItem("BerPay_Admin", JSON.stringify(data));
          }
          // console.log("_)_)_)_)_", token, parsedString, data);

          hist.push("/admin/manageCustomers");
        } else {
          hist.push("/admin/pages/login-page");
        }
      }
      if (BerPay_Admin.token) {
        hist.push("/admin/manageCustomers");
      }
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        {/* <PagesHeader {...rest} /> */}
        <div className={classes.wrapper} ref="wrapper">
          <div
            className={classes.fullPage}
            style={{ backgroundImage: "url(" + bgImage + ")" }}
          >
            <Switch>
              {pagesRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return null;
                }
                if (prop.redirect) {
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                }
                if (
                  window.location.pathname &&
                  window.location.pathname.includes(
                    "/admin/pages/resetPassword"
                  )
                ) {
                  return <ChangePassword />;
                }

                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer white />
          </div>
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(pagesStyle)(Pages);
